import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmareRelatieComponent } from './confirmare-relatie.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddConfirmareRelatieComponent } from './add-confirmare-relatie/add-confirmare-relatie.component';
import { EditConfirmareRelatieComponent } from './edit-confirmare-relatie/edit-confirmare-relatie.component';

@NgModule({
    declarations: [
        ConfirmareRelatieComponent,
        AddConfirmareRelatieComponent,
        EditConfirmareRelatieComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [ConfirmareRelatieComponent],
})
export class ConfirmareRelatieModule { }
